<template>
  <div class="window service-window add-main-service-window"
       v-show="isVisible">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="window-title">{{ isNew ? 'Добавить' : 'Редактировать' }} услугу</div>
    <div class="form">
      <div class="title">Услуга:
        <span class="service-delete" v-show="!isNew" @click="deleteService(serviceIndex)"><i class="fa fa-trash-o"></i>Удалить</span>
      </div>
      <div class="service-main-info">
        <div class="visibility">
          <fieldset class="service" :disabled="!isNew">
            <select v-model="localServiceNr">
              <option disabled :value="null">-- Выбрать --</option>
              <option :value="0">Грузоперевозки</option>
              <option :value="1">Грузчики</option>
              <option :value="2">Сборка мебели</option>
              <option :value="3">ГСМ</option>
              <option :value="4">Сутки простоя</option>
              <option :value="5">Вывоз мусора</option>
            </select>
          </fieldset>
          <fieldset class="quantity">
            <span>x</span>
            <input type="number" v-model="count" placeholder="1" @input="inputCount">
            <span>шт.</span>
          </fieldset>
        </div>
      </div>
      <trucking-service :isVisible="localServiceNr == 0"
                        :index="serviceIndex"
                        :isNew="isNew"
                        :count="count"
                        :addressesFromOrder="addresses"
                        :orderDateTime="orderDateTime"
                        @close-window="closeWindow"></trucking-service>
      <mover-service :isVisible="localServiceNr == 1"
                     :index="serviceIndex"
                     :isNew="isNew"
                     :count="count"
                     :addressesFromOrder="addresses"
                     :orderDateTime="orderDateTime"
                     @close-window="closeWindow"></mover-service>
      <furniture-service :isVisible="localServiceNr == 2"
                         :index="serviceIndex"
                         :isNew="isNew"
                         :count="count"
                         :addressesFromOrder="addresses"
                         :orderDateTime="orderDateTime"
                         @close-window="closeWindow"></furniture-service>
      <petrol-service :isVisible="localServiceNr == 3"
                      :index="serviceIndex"
                      :isNew="isNew"
                      :addressesFromOrder="addresses"
                      :clientAddresses="clientAddresses"
                      :count="count"
                      :isForPetrolService="true"
                      :autoDistanceFromOrder="autoDistance"
                      :manualDistanceFromOrder="manualDistance"
                      :orderDateTime="orderDateTime"
                      :orderStatus="orderStatus"
                      @close-window="closeWindow"></petrol-service>
      <downtime-service :isVisible="localServiceNr == 4"
                        :index="serviceIndex"
                        :isNew="isNew"
                        :count="count"
                        :orderDateTime="orderDateTime"
                        @close-window="closeWindow"></downtime-service>
      <garbage-removal-service :isVisible="localServiceNr == 5"
                               :index="serviceIndex"
                               :isNew="isNew"
                               :count="count"
                               :addressesFromOrder="addresses"
                               :orderDateTime="orderDateTime"
                               @close-window="closeWindow"></garbage-removal-service>
    </div>
  </div>
</template>
<script>
    import DowntimeService from '@/views/DowntimeService.vue'
    import FurnitureService from '@/views/FurnitureService.vue'
    import GarbageRemovalService from '@/views/GarbageRemovalService.vue'
    import PetrolService from '@/views/PetrolService.vue'
    import MoverService from '@/views/MoverService.vue'
    import TruckingService from '@/views/TruckingService.vue'

    export default {
  name: 'MainService',
  props: ['isVisible', 'serviceNr', 'serviceIndex', 'isNew', 'addresses', 'clientAddresses', 'autoDistance', 'manualDistance', 'orderDateTime', 'orderStatus'],
  data () {
    return {
      localServiceNr: this.serviceNr,
      count: 1
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        if (!this.isNew) { this.count = this.$store.getters.groupedServices[this.serviceIndex].length } else { this.count = 1 }
        this.localServiceNr = this.serviceNr
      }
    }
  },

  components: {
    DowntimeService,
    FurnitureService,
    GarbageRemovalService,
    PetrolService,
    MoverService,
    TruckingService
  },
  methods: {
    closeWindow () {
      this.$emit('close-window', false)
      this.localServiceNr = null
    },

    deleteService (index) {
      this.$store.commit('deleteGroupedServiceByIndex', index)
      this.closeWindow()
      this.localServiceNr = null
    },

    inputCount () {
      if (this.count <= 0 && this.count.length > 0) { this.count = 1 }
    }
  }
}
</script>
